import { createMachine } from 'xstate';



export const popupMachine = createMachine({
    /** @xstate-layout N4IgpgJg5mDOIC5QAcD2yCuyB0BJAIgDICiAxOmAHYCyVGA2gAwC6iKqsAlgC6eqVsQAD0QBaAEwA2AMzYAHAFZp0xQoCMC8QBYtagDQgAnojWSA7Ng1qzjBYzVzGclWYC+rg2kw4CJcpQBxAEMAWzAABSCMWEgmViQQNC5efkERBBUATmwtGVsbTLkZM3EFA2MEK0t1aQUlZVrM6XdPdCxsAHlw4gA5AH1qXoBVUgBjABsOMDjBJJ4+AQT00TM5HNyzaUknXWUtOXKTNY0zTJKFTPM6mRbEtpwAYUIOgGUyGYS5lMXQdLVpLTYTL2SRaTIKMGSTSHBBSNZyBGZJpaRjSVFaW5edpPV5kISwbhBbhgbBBABmxIATgAKOyMACUpCxj2ebw+7GSCzSiHEanElkYkikClWmWs0n0RhM1nkQrMkjkp20ukkmPunW6-QA6rgemNJjF2XdOaklmI1JlAVplEo5ZbNloYVpedhUYL1HJefLpGd3B4QJRUBA4LN7qGTT9hGIJQogXJwYiZHVxDCJGpGEDzPG5P9TpoSmrvHgiMRw-NTb8xFILIUE-Gk9CpQhRHzZBt46dLepGFoFIX2l1egNhmXvtzm6ULGDFbyxYxxE1pDCodhNJdewqzBcUW5-czsDi3qOuWbYbHGIxwd7lGZTqYyk3nWpXWioQ4vTJfXv1YPtbrjxWUbNpI2TiKcKI+jozqKAcTYivyYJIkhyFIn6rhAA */
    predictableActionArguments: true,
    id: 'popup',
    initial: 'IDLE',
    context: {
        campaingState: {},

    },

    states: {
        IDLE: {

            entry: ['subscribeWin'],
            exit: ['unsubscribeWin'],

            on: {
                openMenu: "OPEN_MENU",

                onGamePaused: {
                    target: "OPEN_WIN",
                    cond: "hasWins"
                },

                onPause: {
                    target: "PAUSE"
                }


            }
        },

        PAUSE: {
            // entry: ["pauseGame"],
            on: {
                onResume: "IDLE"
            }

        },

        OPEN_MENU: {
            entry: ["updateAllData", "pauseGame"],

            on: {
                //close: "CLOSE"
                close: "IDLE"
            }
        },

        CLOSE: {
            always: {
                target: "IDLE",
                //cond: "hasNoWins"
            },

            // after: {

            //     "500": {
            //         target: "OPEN_WIN",
            //         cond: "hasWins"
            //     }
            // }
        },

        OPEN_WIN: {

            exit: ['clearWin'],

            on: {
                close: "IDLE"
            }
        }
    }
},
    {
        actions: {
            // action implementations
            subscribeWin: (context, event) => {
                //console.log('activating...');
            },
            unsubscribeWin: (context, event) => {
                //console.log('dactivating...');
            },
            clearWin: () => { }

        },
        guards: {
            hasWins: (context) => (true),
            // hasNoWins: (context) => (false)

        },


    }

);